<section class="w3l-form-25">
  <div class="form-inner-cont">
    <div class="w3l-form-25">
      <h1>Patient Annex</h1>
      <p>Enter Annex Data </p>
    </div>
  </div>
</section>

<div id="w3l-appointment">
  <section class="appointment-section section-gap">
    <form action="#" method="post" style="align-content: center;align-items: center;">
      <div class="styled-input">
        <div class="appointment-form-field">
          <label>                                                     M.R.N    </label>
          <span type="submit" class="fa fa-search" (click)="openDialog()" style="cursor: grab;"></span>
          <input type="text" [(ngModel)]="patientCode" (change)="RetrivePatient()" name="patientId" placeholder="Pat. Code" style="width: 7%;" required disabled>
          <input type="text" [(ngModel)]="patientFName" name="patientName" disabled style="width: 20%;">
          <label>                  Date    </label>
          <span class="fa fa-calendar" aria-hidden="true"></span>
          <input type="date" [(ngModel)]="currentdate" name="date" id="wdate" required="" style="width: 13%;">

        </div>
      </div>
    </form>
    <div class="registerimg">
      <div class="clear"> </div>
      <label>            Annex                                            </label>
      <canvas #canvas width="1019" height="557" src="assets/images/Annex.jpg" (click)="animate()"></canvas>
    </div>
    <div class="styled-input">
      <label>                                                                                                                                    </label>
      <button (click)="toRedColor()"
        style="background-color: red;font: bold;color: white;height: 35px;">            Primary        </button>
      <button (click)="toGreenColor()"
        style="background-color: green;font: bold;color: white;height: 35px;">           Secondary        </button>
    </div>
    <label>                                                                                                                      </label>
    <button type="button" class="theme-button btn" (click)="addPatientAnnex()" name="submit">Submit</button>
    <button type="button" class="theme-button btn" (click)="mesgDelete()" name="Delete">Delete</button>
    <button type="button" class="theme-button btn" name="New">New</button>
    <a href="Home">
      <button type="button" class="theme-button btn" name="Back">Home</button>
    </a>
  </section>
</div>
